






















































































import BaseDialog from '@/components/BaseDialog.vue';

import { PropType } from 'vue';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { TStreamRecord } from '@/api/schema';
import {
  formatDuration,
  isDisabledDownloadRecordStatus,
  isPreparingDownloadStatus,
  isReadyDownloadStatus
} from '@/views/CopyStake/CopyStakeStreamRecordings/CopyStakeStreamRecordingsHelper';

export default {
  name: 'CopyStakeStreamRecordPlayerModal',
  components: {
    BaseDialog
  },
  props: {
    streamRecord: {
      type: Object as PropType<TStreamRecord | null>,
      default: null
    },
    value: {
      type: Boolean,
      default: (): boolean => false
    }
  },
  data(): any {
    return {
      player: null,
      playerKey: 0
    };
  },
  computed: {
    streamRecordDetails(): TStreamRecord | null {
      return this.streamRecord || null;
    },
    recordingUrl(): string | null {
      return (
        this.streamRecordDetails?.playListUrl ||
        this.streamRecordDetails?.livePlaylistUrl ||
        null
      );
    },
    shouldInitPlayer(): boolean {
      return this.value && !!this.recordingUrl;
    },
    isPreparingDownloadStreamRecordStatus(): boolean {
      return isPreparingDownloadStatus(
        this.streamRecordDetails?.downloadStatus
      );
    },
    downloadStreamRecordBtnParams(): any {
      if (!this.streamRecordDetails) {
        return {
          disabled: true,
          text: 'Request Download'
        };
      }

      const isPreparing = isPreparingDownloadStatus(
        this.streamRecordDetails.downloadStatus
      );
      const isDisabledRecordStatus = isDisabledDownloadRecordStatus(
        this.streamRecordDetails.status
      );
      const isReady = isReadyDownloadStatus(
        this.streamRecordDetails.downloadStatus
      );

      return {
        disabled: isPreparing || isDisabledRecordStatus,
        text: isReady
          ? 'Download'
          : isPreparing
          ? 'Video is preparing...'
          : 'Request Download'
      };
    }
  },
  watch: {
    shouldInitPlayer: {
      handler(should: boolean): void {
        if (should) {
          this.initPlayer();
        } else {
          this.disposePlayer();
        }
      },
      immediate: true
    }
  },
  beforeDestroy(): void {
    this.disposePlayer();
  },
  methods: {
    async initPlayer(): Promise<void> {
      if (!this.recordingUrl) {
        this.disposePlayer();
        return;
      }

      this.disposePlayer();

      await this.$nextTick();

      if (!this.$refs.videoPlayer) return;

      this.player = videojs(this.$refs.videoPlayer as HTMLVideoElement, {
        controls: true,
        fluid: true,
        responsive: true,
        preload: 'auto',
        sources: [
          {
            src: this.recordingUrl,
            type: 'application/x-mpegURL'
          }
        ],
        html5: {
          hls: {
            overrideNative: true
          },
          nativeVideoTracks: false,
          nativeAudioTracks: false,
          nativeTextTracks: false
        }
      });

      this.player.on('error', () => {
        const error = this.player?.error();
        console.error('[VideoPlayer] Playback error:', error);
      });
    },
    disposePlayer(): void {
      if (!this.player) return;

      this.player.dispose();
      this.player = null;

      this.playerKey += 1;
    },
    formatDuration,
    handleDownloadStreamRecordClick(): void {
      if (!this.streamRecordDetails) return;

      this.$emit('download-stream-record', this.streamRecordDetails);
    }
  }
};
